module.exports = __webpack_public_path__ + "img/IMG_1347.513c67d4.png";